module.exports = function() {
  return new Worker(__webpack_public_path__ + "2511c77fdff09f1dd07a.worker.js");
};